import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { VacationRentalAwarenessModal } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { getRewardsAccountWithLargestEarnForBanner } from "../../../rewards/reducer/selectors";
import { getHasSeenVRAwareness } from "../../reducer/selectors";
import { actions } from "../../actions";
import { Dispatch } from "@reduxjs/toolkit";

const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  open: getHasSeenVRAwareness(state) === false,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose: () => {
    dispatch(actions.updateHasSeenVRAwareness(true));
  },
  fetchHasSeenVRAwareness: () => dispatch(actions.fetchHasSeenVRAwareness()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type VacationRentalAwarenessModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedVacationRentalAwarenessModal = withRouter(
  connector(VacationRentalAwarenessModal)
);
